'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var changeShopCommon = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2, callback) {
    var shop = _ref2.shop,
        dispatch = _ref2.dispatch,
        getState = _ref2.getState;

    var _getState, bookingStore, resSlots, bookingServices, resService, services;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), bookingStore = _getState.booking;

            if (!shop) {
              _context.next = 27;
              break;
            }

            // Reset lại một số trường submit
            dispatch({
              type: RESET_BY_BRANCH
            });
            // gắn shop cho submit
            dispatch({
              type: CHANGE_SUBMIT,
              key: 'shop',
              value: shop
            });

            dispatchInit(dispatch, [LOAD_SERVICE, LOAD_SLOTS]);
            _context.prev = 5;
            _context.next = 8;
            return _ApiClient.client.get('/booking/bookingIn2Week?shop=' + shop.handle);

          case 8:
            resSlots = _context.sent;

            dispatchSuccess(dispatch, LOAD_SLOTS_SUCCESS, LOAD_SLOTS_FAIL, resSlots);
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](5);

            dispatchFail(dispatch, [LOAD_SLOTS_FAIL]);

          case 15:
            bookingServices = bookingStore.submit.bookingServices;
            _context.prev = 16;
            _context.next = 19;
            return _ApiClient.client.get('/service/loadAllForBooking?shopId=' + shop._id);

          case 19:
            resService = _context.sent;

            dispatchSuccess(dispatch, LOAD_SERVICE_SUCCESS, LOAD_SERVICE_FAIL, resService);
            if (bookingServices.length) {
              services = _support.Helper.groupServicesToServices(resService.data);

              bookingServices.forEach(function (v) {
                var exist = services.filter(function (s) {
                  return s._id === v.service || s.service === v.service;
                });
                if (exist && exist.length === 0 && callback && typeof callback === 'function') {
                  var title = { text: 'Thông báo', type: 'warn' };
                  var message = [{ text: 'Chi nh\xE1nh b\u1EA1n v\u1EEBa ch\u1ECDn kh\xF4ng c\xF3 d\u1ECBch v\u1EE5 ' + v.name + '.' }];
                  // callback để báo lỗi khi shop thay đổi không có dịch vụ đã được chọn trước đó.
                  callback({ title: title, message: message });
                }
              });
            }
            _context.next = 27;
            break;

          case 24:
            _context.prev = 24;
            _context.t1 = _context['catch'](16);

            dispatchFail(dispatch, [LOAD_SERVICE_FAIL]);

          case 27:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[5, 12], [16, 24]]);
  }));

  return function changeShopCommon(_x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = reducer;
exports.setSubmit = setSubmit;
exports.loadSlots = loadSlots;
exports.loadWeek = loadWeek;
exports.nextWeek = nextWeek;
exports.previousWeek = previousWeek;
exports.resetBooking = resetBooking;
exports.resetByBranch = resetByBranch;
exports.changeDate = changeDate;
exports.changeBookingTime = changeBookingTime;
exports.loadBookingTime = loadBookingTime;
exports.changeProvinceBooking = changeProvinceBooking;
exports.changeDistrictBooking = changeDistrictBooking;
exports.changeAddressBooking = changeAddressBooking;
exports.restoreAddress = restoreAddress;
exports.resetAddress = resetAddress;
exports.loadDistrictBooking = loadDistrictBooking;
exports.loadService = loadService;
exports.loadAllCoupon = loadAllCoupon;
exports.changeShop = changeShop;
exports.changeShopBeforeBooking = changeShopBeforeBooking;
exports.changeAmount = changeAmount;
exports.changeService = changeService;
exports.changeNote = changeNote;
exports.changeCoupon = changeCoupon;
exports.removeCoupon = removeCoupon;
exports.totalAmount = totalAmount;
exports.resetPricing = resetPricing;
exports.changeContact = changeContact;
exports.submitBooking = submitBooking;
exports.loadBookingRequest = loadBookingRequest;
exports.cancelBookingRequest = cancelBookingRequest;
exports.loadAllBookingRequest = loadAllBookingRequest;
exports.setDefaultBooking = setDefaultBooking;
exports.loadCampaignByCode = loadCampaignByCode;
exports.changeBooking = changeBooking;
exports.changeCode = changeCode;

var _support = require('helpers/support');

var _ApiClient = require('helpers/ApiClient');

var _localStorage = require('utils/localStorage');

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { clone } from 'lodash';
var RESET = 'lookme/booking/RESET';
var RESET_PRICING = 'lookme/booking/RESET_PRICING';
var RESET_BY_BRANCH = 'lookme/booking/RESET_BY_BRANCH';
var LOAD_SLOTS = 'lookme/booking/LOAD_SLOTS';
var LOAD_SLOTS_SUCCESS = 'lookme/booking/LOAD_SLOTS_SUCCESS';
var LOAD_SLOTS_FAIL = 'lookme/booking/LOAD_SLOTS_FAIL';
var CHANGE_SUBMIT = 'lookme/booking/CHANGE_SUBMIT';
var LOAD_WEEK = 'lookme/booking/LOAD_WEEK';
var NEXT_WEEK = 'lookme/booking/NEXT_WEEK';
var PREVIOUS_WEEK = 'lookme/booking/PREVIOUS_WEEK';
var CHANGE_DATE = 'lookme/booking/CHANGE_DATE';
var LOAD_BOOKING_TIME = 'lookme/booking/LOAD_BOOKING_TIME';
var CHANGE_BOOKING_TIME = 'lookme/booking/CHANGE_BOOKING_TIME';

var LOAD_ALL_COUPON = 'lookme/booking/LOAD_ALL_COUPON';
var LOAD_ALL_COUPON_SUCCESS = 'lookme/booking/LOAD_ALL_COUPON_SUCCESS';
var LOAD_ALL_COUPON_FAIL = 'lookme/booking/LOAD_ALL_COUPON_FAIL';

var LOAD_SERVICE = 'lookme/booking/LOAD_SERVICE';
var LOAD_SERVICE_SUCCESS = 'lookme/booking/LOAD_SERVICE_SUCCESS';
var LOAD_SERVICE_FAIL = 'lookme/booking/LOAD_SERVICE_FAIL';

var CHANGE_SERVICE = 'lookme/booking/CHANGE_SERVICE';
var CHANGE_COUPON = 'lookme/booking/CHANGE_COUPON';
var REMOVE_COUPON = 'lookme/booking/REMOVE_COUPON';

var TOTAL_AMOUNT = 'lookme/booking/TOTAL_AMOUNT';
var TOTAL_AMOUNT_SUCCESS = 'lookme/booking/TOTAL_AMOUNT_SUCCESS';
var TOTAL_AMOUNT_FAIL = 'lookme/booking/TOTAL_AMOUNT_FAIL';

var CHANGE_CONTACT = 'lookme/booking/CHANGE_CONTACT';

var SUBMIT = 'lookme/booking/SUBMIT';
var SUBMIT_SUCCESS = 'lookme/booking/SUBMIT_SUCCESS';
var SUBMIT_FAIL = 'lookme/booking/SUBMIT_FAIL';

var LOAD_BOOKING_REQUEST = 'lookme/booking/LOAD_BOOKING_REQUEST';
var LOAD_BOOKING_REQUEST_SUCCESS = 'lookme/booking/LOAD_BOOKING_REQUEST_SUCCESS';
var LOAD_BOOKING_REQUEST_FAIL = 'lookme/booking/LOAD_BOOKING_REQUEST_FAIL';

var CANCEL_BOOKING_REQUEST = 'lookme/booking/CANCEL_BOOKING_REQUEST';
var CANCEL_BOOKING_REQUEST_SUCCESS = 'lookme/booking/CANCEL_BOOKING_REQUEST_SUCCESS';
var CANCEL_BOOKING_REQUEST_FAIL = 'lookme/booking/CANCEL_BOOKING_REQUEST_FAIL';

var LOAD_ALL_BOOKING_REQUEST = 'lookme/booking/LOAD_ALL_BOOKING_REQUEST';
var LOAD_ALL_BOOKING_REQUEST_SUCCESS = 'lookme/booking/LOAD_ALL_BOOKING_REQUEST_SUCCESS';
var LOAD_ALL_BOOKING_REQUEST_FAIL = 'lookme/booking/LOAD_ALL_BOOKING_REQUEST_FAIL';

var LOAD_CAMPAIGN_BY_CODE = 'lookme/booking/LOAD_CAMPAIGN_BY_CODE';
var LOAD_CAMPAIGN_BY_CODE_SUCCESS = 'lookme/booking/LOAD_CAMPAIGN_BY_CODE_SUCCESS';
var LOAD_CAMPAIGN_BY_CODE_FAIL = 'lookme/booking/LOAD_CAMPAIGN_BY_CODE_FAIL';

var SET_DEFAULT_SUBMIT = 'lookme/booking/SET_DEFAULT_SUBMIT';
var SET_BRANCH = 'lookme/booking/SET_BRANCH';

var CHANGE_BOOKING = 'lookme/booking/CHANGE_BOOKING';

var RESET_ADDRESS = 'lookme/booking/RESET_ADDRESS';
var RESTORE_ADDRESS = 'lookme/booking/RESTORE_ADDRESS';
var CHANGE_PROVINCE = 'lookme/booking/CHANGE_PROVINCE';
var CHANGE_DISTRICT = 'lookme/booking/CHANGE_DISTRICT';
var CHANGE_ADDRESS = 'lookme/booking/CHANGE_ADDRESS';
var LOAD_DISTRICT = 'lookme/booking/LOAD_DISTRICT';
var LOAD_DISTRICT_SUCCESS = 'lookme/booking/LOAD_DISTRICT_SUCCESS';
var LOAD_DISTRICT_FAIL = 'lookme/booking/LOAD_DISTRICT_FAIL';

// const CHECK_VALID_CODE = 'lookme/booking/CHECK_VALID_CODE';
var CHANGE_CODE = 'lookme/booking/CHANGE_CODE';
// const CHECK_VALID_CODE_FAIL = 'lookme/booking/CHECK_VALID_CODE_FAIL';

// Tất tần tật cái state nào mình muốn reset bỏ ở đây
var initialState = {
  branchs: [],
  bookingTime: [],
  // shop ngoài đây sẽ làm cho luồng cũ, chưa có
  shop: null,
  submit: {
    slot: 1,
    noteByUser: '',
    bookingTimeId: '',
    bookingServices: [],
    userInfo: {
      name: '',
      phone: ''
    },
    code: '',
    shop: null,
    dateSelected: null,
    time: null,
    coupon: null,
    atHome: false,
    district: null,
    province: null,
    address: null
  },
  isBooking: false,
  // Kiểm tra code có phải là code nhập hoặc code chọn từ ưu đãi của tôi
  enterTheCode: false,
  bookingSuccess: null,
  bookingError: null,
  district_loaded: false,
  loadDistrictError: null,
  couponData: {
    type: 'default',
    name: 'Nhập mã giảm giá',
    leftIcon: '/booking/discount.png'
  },
  pricing: { total: 0, totalCost: 0 },
  bill: null
};
var initialPricing = {
  isPricing: false,
  pricing: { total: 0, totalCost: 0 },
  bill: null
};
// Những state của booking nhưng lại không ảnh hưởng bởi reset. Thường là dữ liệu render bla bla...
var bookingState = (0, _extends3.default)({}, initialState, initialPricing, {
  isLoading: false,
  groupServices: null,
  services: null,
  bookingTimes: null,
  weeks: null,
  week: null,
  page: 0,
  bookingRequest: null,
  bookingRequestError: null,
  bookingRequests: null,
  bookingRequestsError: null,
  cancelBooking: null,
  toggleCancelSuccess: false,
  cancelBookingError: null,
  toggleCancelError: false,
  provinceActive: null,
  districtActive: null,
  addressActive: null,
  provines: null,
  districts: null,
  // Biến này dùng để handle back
  backBookingSuccess: false
  // Biến này dùng để checkUser booking khi chưa login và phải login ở bước 3.
});
var initialByBranch = {
  bookingTime: [],
  submit: {
    dateSelected: null
  }
};
function newWeekUI(page, state) {
  var weekUI = (0, _extends3.default)({}, state.weekUI);
  var weeks = state.weeks;

  weekUI = (0, _extends3.default)({}, weekUI, {
    btnPrevious: !!weeks[page - 1],
    btnNext: !!weeks[page + 1]
  });
  return weekUI;
}
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bookingState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case RESET:
      return (0, _extends3.default)({}, state, initialState);
    case RESET_PRICING:
      return (0, _extends3.default)({}, state, initialPricing);
    case RESET_BY_BRANCH:
      {
        var submit = (0, _extends3.default)({}, state.submit, initialByBranch.submit);
        return (0, _extends3.default)({}, state, initialByBranch, {
          submit: submit
        });
      }
    case LOAD_SLOTS:
      return (0, _extends3.default)({}, state);
    case LOAD_SLOTS_SUCCESS:
      {
        var _Helper$slitWeek = _support.Helper.slitWeek(action.result.data),
            weeks = _Helper$slitWeek.weeks,
            bookingTimes = _Helper$slitWeek.bookingTimes;

        return (0, _extends3.default)({}, state, {
          weeks: weeks,
          bookingTimes: bookingTimes
        });
      }
    case LOAD_SLOTS_FAIL:
      return (0, _extends3.default)({}, state);
    case CHANGE_SUBMIT:
      {
        var _submit = (0, _extends3.default)({}, state.submit);
        var key = action.key,
            value = action.value;

        if (_submit.hasOwnProperty(key)) {
          _submit[key] = value;
        }
        return (0, _extends3.default)({}, state, {
          submit: _submit
        });
      }
    case SET_DEFAULT_SUBMIT:
      {
        return (0, _extends3.default)({}, state, {
          submit: (0, _extends3.default)({}, state.submit, action.submit)
        });
      }
    case LOAD_WEEK:
      {
        var page = state.page,
            _weeks = state.weeks;

        var week = [];
        if (_weeks[page] && _weeks[page].length) {
          week = _weeks[page];
        }
        var weekUI = newWeekUI(page, state);
        return (0, _extends3.default)({}, state, {
          week: week,
          weekUI: weekUI
        });
      }
    case NEXT_WEEK:
      {
        var _weeks2 = state.weeks;
        var _page = state.page;

        var _week = [].concat((0, _toConsumableArray3.default)(state.week));
        if (_weeks2[_page + 1] && _weeks2[_page + 1].length) {
          _page++;
          _week = _weeks2[_page];
        }
        var _weekUI = newWeekUI(_page, state);
        return (0, _extends3.default)({}, state, {
          week: _week,
          page: _page,
          weekUI: _weekUI
        });
      }
    case PREVIOUS_WEEK:
      {
        var _weeks3 = state.weeks;
        var _page2 = state.page;

        var _week2 = [].concat((0, _toConsumableArray3.default)(state.week));
        if (_weeks3[_page2 - 1] && _weeks3[_page2 - 1].length) {
          _page2--;
          _week2 = _weeks3[_page2];
        }
        var _weekUI2 = newWeekUI(_page2, state);
        return (0, _extends3.default)({}, state, {
          week: _week2,
          page: _page2,
          weekUI: _weekUI2
        });
      }
    case CHANGE_DATE:
      {
        var dateSelected = state.submit.dateSelected;
        var data = action.data;

        if (dateSelected === null || data && data.date !== dateSelected.date) {
          var _submit2 = (0, _extends3.default)({}, state.submit, {
            bookingTimeId: '',
            dateSelected: data,
            time: null
          });
          return (0, _extends3.default)({}, state, {
            submit: _submit2
          });
        }
        return (0, _extends3.default)({}, state);
      }
    case LOAD_BOOKING_TIME:
      {
        var date = action.date;
        var _bookingTimes = state.bookingTimes;

        var _key = (0, _moment2.default)(date).format('YYYY-MM-DD');
        var bookingTime = [];
        if (_bookingTimes.hasOwnProperty(_key)) {
          bookingTime = [].concat((0, _toConsumableArray3.default)(_bookingTimes[_key]));
          var today = (0, _moment2.default)().startOf('day');
          var theDay = (0, _moment2.default)(_key);
          if (today.valueOf() === theDay.valueOf()) {
            // Trường hợp trong ngày: chỉ lấy thời gian phù hợp.
            var now = (0, _moment2.default)();
            var mins = now.hour() * 60 + now.minutes();
            bookingTime = _bookingTimes[_key].filter(function (v) {
              return v.time >= mins;
            });
          }
        }
        return (0, _extends3.default)({}, state, {
          bookingTime: bookingTime
        });
      }
    case CHANGE_BOOKING_TIME:
      {
        var _data = action.data;

        var _submit3 = (0, _extends3.default)({}, state.submit, {
          time: _data,
          bookingTimeId: _data._id,
          slot: 1
        });
        return (0, _extends3.default)({}, state, {
          submit: _submit3
        });
        // const submit = {...this.submit, bookingTimeId: _id, time, slot: 1};
        // this.submit = submit;
        // this.changeTotalAmount(200);
      }
    case LOAD_ALL_COUPON:
      {
        return (0, _extends3.default)({}, state, {
          coupons: []
        });
      }
    case LOAD_ALL_COUPON_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          coupons: action.result.data
        });
      }
    case LOAD_ALL_COUPON_FAIL:
      {
        return (0, _extends3.default)({}, state);
      }
    case LOAD_SERVICE:
      {
        return (0, _extends3.default)({}, state);
      }
    case LOAD_SERVICE_SUCCESS:
      {
        var _data2 = action.result.data;

        var services = _support.Helper.groupServicesToServices(_data2);
        return (0, _extends3.default)({}, state, {
          groupServices: action.result.data,
          services: services
        });
      }
    case LOAD_SERVICE_FAIL:
      {
        return (0, _extends3.default)({}, state);
      }
    case CHANGE_SERVICE:
      {
        var service = action.service;
        var bookingServices = [];
        if (state.submit.bookingServices && state.submit.bookingServices.length) {
          for (var i = 0, len = state.submit.bookingServices.length; i < len; i++) {
            var item = (0, _lodash.clone)(state.submit.bookingServices[i]);
            bookingServices.push(item);
          }
        }
        if (service) {
          var number = service.number;
          if (number === 0) {
            bookingServices = _support.Helper.removeServices(bookingServices, service);
          } else {
            bookingServices = _support.Helper.updateServices(bookingServices, service);
          }
        }
        _support.Helper.warn('CHANGE_SERVICE service', service);
        _support.Helper.warn('CHANGE_SERVICE bookingServices', bookingServices);
        return (0, _extends3.default)({}, state, {
          submit: (0, _extends3.default)({}, state.submit, {
            bookingServices: bookingServices
          })
        });
      }
    case CHANGE_COUPON:
      {
        var coupon = action.coupon;

        var code = coupon.code;
        var _submit4 = (0, _extends3.default)({}, state.submit, { coupon: coupon, code: code });
        return (0, _extends3.default)({}, state, {
          submit: _submit4,
          enterTheCode: false
        });
      }
    case REMOVE_COUPON:
      {
        var _submit5 = (0, _extends3.default)({}, state.submit, { coupon: null, code: '' });
        return (0, _extends3.default)({}, state, {
          submit: _submit5
        });
      }
    case TOTAL_AMOUNT:
      {
        return (0, _extends3.default)({}, state, {
          isPricing: true
        });
      }
    case TOTAL_AMOUNT_SUCCESS:
      {
        var _code = state.submit.code;

        return (0, _extends3.default)({}, state, {
          isPricing: false,
          pricing: _support.Helper.billData(action.result.data),
          couponData: _support.Helper.makeCouponData(_code, action.result.codeError)
        });
      }
    case TOTAL_AMOUNT_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          isPricing: false
        });
      }
    case CHANGE_CONTACT:
      {
        var userInfo = action.userInfo;

        return (0, _extends3.default)({}, state, {
          submit: (0, _extends3.default)({}, state.submit, {
            userInfo: userInfo
          })
        });
      }
    case SUBMIT:
      {
        return (0, _extends3.default)({}, state, {
          isBooking: true,
          bookingSuccess: null,
          bookingError: null
        });
      }
    case SUBMIT_SUCCESS:
      {
        _support.Helper.prints('booking 401, ', action.result);
        return (0, _extends3.default)({}, state, {
          isBooking: false,
          bookingSuccess: action.result
        });
      }
    case SUBMIT_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          isBooking: false,
          bookingError: action.error.errors
        });
      }
    case LOAD_BOOKING_REQUEST:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: true
        });
      }
    case LOAD_BOOKING_REQUEST_SUCCESS:
      {
        console.log('LOAD_BOOKING_REQUEST_SUCCESS', action.result, _support.Helper.bookingRequestData(action.result.bookingRequest));
        return (0, _extends3.default)({}, state, {
          isLoading: false,
          bookingRequest: _support.Helper.bookingRequestData(action.result.bookingRequest),
          bill: _support.Helper.billData(action.result.bill)
        });
      }
    case LOAD_BOOKING_REQUEST_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: false,
          bookingRequestError: action.error.errors
        });
      }
    case CANCEL_BOOKING_REQUEST:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: true
        });
      }
    case CANCEL_BOOKING_REQUEST_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: false,
          cancelBooking: action.result,
          toggleCancelSuccess: !state.toggleCancelSuccess
        });
      }
    case CANCEL_BOOKING_REQUEST_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: false,
          cancelBookingError: action.error.errors,
          toggleCancelError: !state.toggleCancelError
        });
      }
    case LOAD_ALL_BOOKING_REQUEST:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: true
        });
      }
    case LOAD_ALL_BOOKING_REQUEST_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: false,
          bookingRequests: _support.Helper.bookingRequestsData(action.result.bookingRequests)
        });
      }
    case LOAD_ALL_BOOKING_REQUEST_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          isLoading: false,
          bookingRequestsError: action.error.errors
        });
      }
    case LOAD_CAMPAIGN_BY_CODE:
      {
        return (0, _extends3.default)({}, state);
      }
    case LOAD_CAMPAIGN_BY_CODE_SUCCESS:
      {
        var _coupon = _support.Helper.campaignData(action.result.campaign);
        var _submit6 = (0, _extends3.default)({}, state.submit, { code: _coupon.code, coupon: _coupon });
        return (0, _extends3.default)({}, state, {
          submit: _submit6
        });
      }
    case LOAD_CAMPAIGN_BY_CODE_FAIL:
      {
        return (0, _extends3.default)({}, state);
      }
    case CHANGE_BOOKING:
      {
        var temp = (0, _extends3.default)({}, state);
        temp[action.key] = action.value;
        return (0, _extends3.default)({}, state, temp);
      }
    case SET_BRANCH:
      {
        _support.Helper.warn('SET_BRANCH', action.branchs);
        return (0, _extends3.default)({}, state, {
          branchs: action.branchs
        });
      }
    case CHANGE_PROVINCE:
      return (0, _extends3.default)({}, state, {
        submit: (0, _extends3.default)({}, state.submit, {
          province: action.data.code,
          district: null
        }),
        provinceActive: action.data,
        districtActive: null
      });
    case CHANGE_DISTRICT:
      return (0, _extends3.default)({}, state, {
        submit: (0, _extends3.default)({}, state.submit, {
          district: action.data.code
        }),
        districtActive: action.data
      });
    case CHANGE_ADDRESS:
      return (0, _extends3.default)({}, state, {
        submit: (0, _extends3.default)({}, state.submit, {
          address: action.data
        }),
        addressActive: action.data
      });
    case RESET_ADDRESS:
      return (0, _extends3.default)({}, state, {
        provinceActive: null,
        districtActive: null,
        addressActive: null,
        provines: null,
        districts: null
      });
    case RESTORE_ADDRESS:
      return (0, _extends3.default)({}, state, {
        submit: (0, _extends3.default)({}, state.submit, {
          address: action.data.address,
          province: action.data.province,
          district: action.data.district
        }),
        addressActive: action.data.address
      });
    case LOAD_DISTRICT:
      return (0, _extends3.default)({}, state, {
        district_loading: true
      });
    case LOAD_DISTRICT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        district_loading: false,
        districts: action.result,
        district_loaded: true
      });
    case LOAD_DISTRICT_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            district_loading: false,
            loadDistrictError: action.error,
            district_loaded: true
          });
        }
      }
    case CHANGE_CODE:
      {
        var _submit7 = (0, _extends3.default)({}, state.submit, {
          code: action.code
        });
        return (0, _extends3.default)({}, state, {
          submit: _submit7
        });
      }
    default:
      return state;
  }
}

function setSubmit(key, value) {
  return {
    type: CHANGE_SUBMIT,
    key: key,
    value: value
  };
}
/* ----------  @ACTIONS  ---------- */
function loadSlots(handle) {
  var apiUrl = '/booking/bookingIn2Week?shop=' + handle;
  return {
    types: [LOAD_SLOTS, LOAD_SLOTS_SUCCESS, LOAD_SLOTS_FAIL],
    promise: function promise(client) {
      return client.get(apiUrl);
    }
  };
}
function loadWeek() {
  return {
    type: LOAD_WEEK
  };
}
function nextWeek() {
  return {
    type: NEXT_WEEK
  };
}
function previousWeek() {
  return {
    type: PREVIOUS_WEEK
  };
}
function resetBooking() {
  return {
    type: RESET
  };
}
function resetByBranch() {
  return {
    type: RESET_BY_BRANCH
  };
}
function changeDate(data) {
  return {
    type: CHANGE_DATE,
    data: data
  };
}
function changeBookingTime(data) {
  return {
    type: CHANGE_BOOKING_TIME,
    data: data
  };
}
function loadBookingTime(date) {
  return {
    type: LOAD_BOOKING_TIME,
    date: date
  };
}
function changeProvinceBooking(province) {
  return {
    type: CHANGE_PROVINCE,
    data: province
  };
}
function changeDistrictBooking(district) {
  return {
    type: CHANGE_DISTRICT,
    data: district
  };
}
function changeAddressBooking(address) {
  return {
    type: CHANGE_ADDRESS,
    data: address
  };
}
function restoreAddress(userAddress) {
  return {
    type: RESTORE_ADDRESS,
    data: userAddress
  };
}
function resetAddress() {
  return {
    type: RESET_ADDRESS
  };
}
function loadDistrictBooking(province) {
  return {
    types: [LOAD_DISTRICT, LOAD_DISTRICT_SUCCESS, LOAD_DISTRICT_FAIL],
    province_code: province,
    promise: function promise(client) {
      return client.get('/address/load-district?province_code=' + province);
    }
  };
}

function loadService(shopId) {
  var apiUrl = '/service/loadAllForBooking?shopId=' + shopId;
  return {
    types: [LOAD_SERVICE, LOAD_SERVICE_SUCCESS, LOAD_SERVICE_FAIL],
    promise: function promise(client) {
      return client.get(apiUrl);
    }
  };
}
function loadAllCoupon(shopId) {
  var apiUrl = '/coupon/loadAllForBooking?shopId=' + shopId;
  return {
    types: [LOAD_ALL_COUPON, LOAD_ALL_COUPON_SUCCESS, LOAD_ALL_COUPON_FAIL],
    promise: function promise(client) {
      return client.get(apiUrl);
    }
  };
}
function dispatchInit(dispatch, types) {
  types.map(function (val) {
    return dispatch({
      type: val
    });
  });
}
function dispatchFail(dispatch, types) {
  types.map(function (val) {
    return dispatch({
      type: val,
      error: { message: 'Lỗi' }
    });
  });
}
function dispatchSuccess(dispatch, typeSuccess, typeFail, res) {
  if (res.success) {
    dispatch({
      type: typeSuccess,
      result: res
    });
  } else {
    dispatch({
      type: typeFail,
      result: res
    });
  }
}

function changeShop(shop, callback) {
  var _this = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (shop) {
                changeShopCommon({ shop: shop, dispatch: dispatch, getState: getState }, callback);
              }
              // console.warn('@changeShop: Bền không truyền shop vô');

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function changeShopBeforeBooking(shop, user) {
  var _this2 = this;

  if (shop && shop.handle) {
    return function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
        var shopData, branchs, submitShop, _user$bookingAddress, province, district, address;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (shop.atHome) {
                  dispatch({
                    type: CHANGE_SUBMIT,
                    key: 'atHome',
                    value: true
                  });
                }

                if (!shop.isChain) {
                  _context3.next = 16;
                  break;
                }

                shopData = {};

                if (!(shop.allShopInChains && shop.allShopInChains.length)) {
                  _context3.next = 7;
                  break;
                }

                shopData = shop;
                _context3.next = 10;
                break;

              case 7:
                _context3.next = 9;
                return _ApiClient.client.get('/shop/get-by-handle/' + shop.handle);

              case 9:
                shopData = _context3.sent;

              case 10:
                branchs = shopData.allShopInChains.filter(function (v) {
                  return v.isBooking;
                });

                dispatch({
                  type: SET_BRANCH,
                  branchs: branchs
                });
                submitShop = branchs.filter(function (v) {
                  return v._id === shopData._id;
                });

                changeShopCommon({ shop: submitShop[0], dispatch: dispatch, getState: getState });
                _context3.next = 17;
                break;

              case 16:
                changeShopCommon({ shop: shop, dispatch: dispatch, getState: getState });

              case 17:
                if (user && shop.atHome && user.bookingAddress) {
                  _user$bookingAddress = user.bookingAddress, province = _user$bookingAddress.province, district = _user$bookingAddress.district, address = _user$bookingAddress.address;

                  dispatch(loadDistrictBooking(province));
                  dispatch(restoreAddress({
                    province: province,
                    district: district,
                    address: address
                  }));
                } else {
                  dispatch(resetAddress());
                }

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }();
  }
}
function changeAmount(number) {
  if (number) return setSubmit('slot', number);
}
function changeService(service) {
  return {
    type: CHANGE_SERVICE,
    service: service
  };
}
function changeNote(noteByUser) {
  if (noteByUser || noteByUser === '') {
    return setSubmit('noteByUser', noteByUser);
  }
}
function changeCoupon(coupon) {
  return {
    type: CHANGE_COUPON,
    coupon: coupon
  };
}
function removeCoupon() {
  return {
    type: REMOVE_COUPON
  };
}
function totalAmount(body) {
  var token = (0, _localStorage.localStore)().get('token');
  return {
    types: [TOTAL_AMOUNT, TOTAL_AMOUNT_SUCCESS, TOTAL_AMOUNT_FAIL],
    promise: function promise(client) {
      return client.post('/booking/calculate-v2', {
        jsonData: (0, _extends3.default)({}, body, { token: token })
      });
    }
  };
}
function resetPricing() {
  return {
    type: RESET_PRICING
  };
}
function changeContact(userInfo) {
  return {
    type: CHANGE_CONTACT,
    userInfo: userInfo
  };
}
function submitBooking(body) {
  var token = (0, _localStorage.localStore)().get('token');
  return {
    types: [SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/booking/submitBooking', {
        jsonData: (0, _extends3.default)({}, body, { token: token })
      });
    }
  };
}

function loadBookingRequest(bookingRequestId) {
  var apiUrl = '/booking/loadBookingRequestForUser/' + bookingRequestId;
  return {
    types: [LOAD_BOOKING_REQUEST, LOAD_BOOKING_REQUEST_SUCCESS, LOAD_BOOKING_REQUEST_FAIL],
    promise: function promise(client) {
      return client.get(apiUrl);
    }
  };
}

function cancelBookingRequest(bookingRequestId) {
  var token = (0, _localStorage.localStore)().get('token');
  var body = { token: token, bookingRequestId: bookingRequestId };
  return {
    types: [CANCEL_BOOKING_REQUEST, CANCEL_BOOKING_REQUEST_SUCCESS, CANCEL_BOOKING_REQUEST_FAIL],
    promise: function promise(client) {
      return client.post('/booking/cancelBookingRequest', {
        data: body
      });
    }
  };
}

function loadAllBookingRequest() {
  var apiUrl = '/booking/loadAllBookingRequest';
  return {
    types: [LOAD_ALL_BOOKING_REQUEST, LOAD_ALL_BOOKING_REQUEST_SUCCESS, LOAD_ALL_BOOKING_REQUEST_FAIL],
    promise: function promise(client) {
      return client.get(apiUrl);
    }
  };
}

function setDefaultBooking(submit) {
  return {
    type: SET_DEFAULT_SUBMIT,
    submit: submit
  };
}

function loadCampaignByCode(code) {
  var apiUrl = '/coupon/loadCampaignByCode?code=' + code;
  return {
    types: [LOAD_CAMPAIGN_BY_CODE, LOAD_CAMPAIGN_BY_CODE_SUCCESS, LOAD_CAMPAIGN_BY_CODE_FAIL],
    promise: function promise(client) {
      return client.get(apiUrl);
    }
  };
}

function changeBooking(key, value) {
  return {
    type: CHANGE_BOOKING,
    key: key,
    value: value
  };
}
function changeCode(code) {
  console.log('changeCode', code);
  return {
    type: CHANGE_CODE,
    enterTheCode: true,
    code: code
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/booking.js
// module id = 41
// module chunks = 0